export default __webpack_public_path__ + "static/media/i.daf8515a.jpg";